import { ALL_KNOWN_DETAILS_TESTIDS } from '../../constants';
import { subLabelFor } from '../../utils/allKnownDetailsUtils';
import type { KnownDetailType, KnownEntityType, KnownSourceGroup } from '../../types';
import SourceValueRow from '../SourceValueRow/SourceValueRow';
import styles from './SourceGroupCluster.module.scss';

interface SourceGroupClusterProps {
    label: string;
    groups: KnownSourceGroup[];
    type: KnownDetailType;
    entityType: KnownEntityType;
}

/** One header over per-instance sub-rows, e.g. GST with a sub-row per GSTIN. */
const SourceGroupCluster = ({ label, groups, type, entityType }: SourceGroupClusterProps) => (
    <div className={styles.Cluster} data-testid={ALL_KNOWN_DETAILS_TESTIDS.SOURCE_CLUSTER}>
        <span className={styles.ClusterHeader} data-testid={ALL_KNOWN_DETAILS_TESTIDS.SOURCE_CLUSTER_HEADER}>
            {label}
        </span>
        {groups.map((group, index) => (
            <div className={styles.ClusterRow} data-testid={ALL_KNOWN_DETAILS_TESTIDS.SOURCE_ROW} key={`${group.sourceId}-${index}`}>
                <SourceValueRow
                    label={group.instanceLabel}
                    subLabel={subLabelFor(group, entityType)}
                    values={group.values ?? []}
                    type={type}
                    isInstance
                />
            </div>
        ))}
    </div>
);

export default SourceGroupCluster;
